import { JwtAxios } from '@/packaging';

export const bulkUploadApi = {
  // 수집설정 목록 조회 (bulk로 시작하는 것만, 등록전/등록 수량 포함)
  async GetBulkCollectGroupList() {
    const responseModel = await JwtAxios.get('/BulkUpload/GetBulkCollectGroups');
    return responseModel;
  },

  // 오픈마켓 계정 목록 조회
  async GetOpenmarketAccountList() {
    const responseModel = await JwtAxios.get('/Template/Market/GetOpenmarketAccountList');
    return responseModel;
  },

  // 마켓 계정별 상품 수 조회
  async GetMarketAccountProductCounts(collectGroupGuid = null) {
    const responseModel = await JwtAxios.post('/BulkUpload/GetMarketAccountProductCounts', { collectGroupGuid });
    return responseModel;
  },

  // 등록된 상품 조회 (기존 MarketProduct API 사용)
  async GetBulkRegisteredProducts(model) {
    const responseModel = await JwtAxios.post('/MarketProduct/SearchUploadProduct', model);
    return responseModel;
  },

  // 등록안된 상품 조회 (기존 Product API 사용)
  async GetBulkStandbyProducts(model) {
    const responseModel = await JwtAxios.post('/Product/SearchProduct', model);
    return responseModel;
  },

  // 등록전 상품(계정별) 조회 - 업로드 이력이 없는 상품까지 포함
  async GetBulkUnregisteredProducts(model) {
    const responseModel = await JwtAxios.post('/BulkUpload/GetUnregisteredProducts', model);
    return responseModel;
  },

  // 분류별 상품 수 조회
  async GetUserTagProductCounts(collectGroupGuid = null) {
    const responseModel = await JwtAxios.post('/BulkUpload/GetUserTagProductCounts', { collectGroupGuid });
    return responseModel;
  },

  // 상품에 분류 등록
  async AssignTagToProducts(model) {
    const responseModel = await JwtAxios.post('/BulkUpload/AssignTagToProducts', model);
    return responseModel;
  },

  // 상품에서 분류 해제
  async RemoveTagFromProducts(model) {
    const responseModel = await JwtAxios.post('/BulkUpload/RemoveTagFromProducts', model);
    return responseModel;
  },

  // 사용자분류(태그) 목록 조회 (MariaDB)
  async GetUserTags() {
    const responseModel = await JwtAxios.get('/BulkUpload/GetUserTags');
    return responseModel;
  },

  // 사용자분류(태그) 생성 (MariaDB)
  async CreateUserTag(model) {
    const responseModel = await JwtAxios.post('/BulkUpload/CreateUserTag', model);
    return responseModel;
  },

  // 사용자분류(태그) 삭제 (MariaDB)
  async DeleteUserTag(model) {
    const responseModel = await JwtAxios.post('/BulkUpload/DeleteUserTag', model);
    return responseModel;
  },

  // 상품 업로드
  async UploadProducts(connectionId, model) {
    const responseModel = await JwtAxios.post(`/BulkUpload/UploadProducts?connectionId=${connectionId}`, model);
    return responseModel;
  },

  // 조회수 조건으로 등록상품 조회 (N개 이하/이상)
  async SearchRegisteredByViews(model) {
    const responseModel = await JwtAxios.post('/BulkUpload/SearchRegisteredByViews', model);
    return responseModel;
  },

  // N일 이상 조회수 없는 등록상품 삭제 (preview=true면 대상 건수만 조회)
  async DeleteNoViewProducts(model) {
    const responseModel = await JwtAxios.post('/BulkUpload/DeleteNoViewProducts', model);
    return responseModel;
  },

  // 상품 업로드 중지 (Redis 업로드 대기열 비우기)
  async StopUpload(connectionId) {
    const responseModel = await JwtAxios.post(`/BulkUpload/StopUpload?connectionId=${connectionId}`);
    return responseModel;
  },

  // 상품 삭제(중지)
  async StopProducts(model) {
    const responseModel = await JwtAxios.post('/BulkUpload/StopProducts', model);
    return responseModel;
  }
};
